<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="客户类型">
              <a-select
                v-model="queryParam.custType"
                placeholder="请选择客户类型"
              >
                <a-select-option value="0">机构</a-select-option>
                <a-select-option value="1">个人</a-select-option>
                <a-select-option value="2"> 产品 </a-select-option>
              </a-select>
              <!-- <a-input
                placeholder="请输入客户类型"
                v-model="queryParam.custType"
              ></a-input> -->
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="客户名称">
              <a-input
                placeholder="请输入客户名称"
                v-model="queryParam.realName"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
                <a-menu slot="overlay">
                  <a-menu-item key="1" @click="batchDel">
                    <a-icon type="delete" />删除</a-menu-item
                  >
                </a-menu>
                <a-button style="margin-left: 8px">
                  批量操作
                  <a-icon type="down" />
                </a-button>
              </a-dropdown> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 查询区域-END -->
    <div class="table-operator">
      <a-button type="primary" icon="import" @click="importFile()"
        >导入</a-button
      >
      <a-button type="primary" icon="download" @click="handleExportExcel()"
        >导出</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="2"><a-icon type="delete" />批量删除</a-menu-item>
          <a-menu-item key="0"
            ><a-icon type="plus" />批量加入黑名单</a-menu-item
          >
          <a-menu-item key="1"
            ><a-icon type="line" />批量移除黑名单</a-menu-item
          >
        </a-menu>
        <a-button> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>
    <!-- 导入 -->
    <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
      <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
      <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
      >项
      <a style="margin-left: 24px" @click="onClearSelected">清空</a>
    </div>
    <a-table
      ref="table"
      size="middle"
      :scroll="{ x: true }"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      class="j-table-force-nowrap"
      @change="handleTableChange"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handlDelete(record.id)">删除</a>
      </span>
      <template slot="isBlackList" slot-scope="text, record">
        <a-switch
          :checked="isChecked(record.isBlackList)"
          checked-children="禁用"
          un-checked-children="未禁用"
          @click="handleChange(record)"
        />
      </template>
    </a-table>
    <a-modal
      title="上传文件"
      :visible="exportVisible"
      @ok="handleImportOk"
      @cancel="handleCancel"
    >
      <form action="">
        <a-form-item label="上传文件">
          <a-upload
            name="file"
            :multiple="true"
            accept=".xls,.xlsx"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :remove="handleRemove"
            @change="handleImport"
            :action="uploadAction"
          >
            <a-button> <a-icon type="upload" />选择文件</a-button>
          </a-upload>
        </a-form-item>
      </form>
      <div v-if="failData.length > 0">
        <p>导入失败名单</p>
        <a-table :columns="failColumns" :data-source="failData"> </a-table>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import JDate from '@/components/jeecg/JDate';
import { filterObj } from '@/utils/util';
import { getAction, downFile, postTag } from '@/api/manage';
import { customerDelete, Blacklist, addBlackListMessage } from '@/api/api';
export default {
  name: 'ProductsQuotationList',
  mixins: [mixinDevice],
  components: {
    JDate,
  },
  data() {
    return {
      headers: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      uploadAction:
        process.env.VUE_APP_GATEWAY_URL + 'system-file-biz/resources/upload',
      failData: [],
      failColumns: [
        {
          title: '姓名',
          dataIndex: 'custName',
          key: 'custName',
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          key: 'mobile',
        },
        {
          title: '原因',
          key: 'invalidReason',
          dataIndex: 'invalidReason',
        },
      ],
      exportVisible: false,
      selectedRowKeys: [],
      title: '原因',
      width: 800,
      fileList: [],
      showDialog: false,
      visible: false,
      showLead: false,
      uploading: false,
      loading: false,
      reason: '', //驳回原因
      selectedRowKeys: [],
      selectedRow: [],
      queryParam: {
        custType: '',
        realName: '',
      },
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      // 表头
      columns: [
        {
          title: '客户名称',
          align: 'center',
          sorter: true,
          dataIndex: 'realName',
        },
        {
          title: '证件类型',
          align: 'center',
          dataIndex: 'cerType',
        },
        {
          title: '证件号码',
          align: 'center',
          dataIndex: 'cerNum',
        },
        {
          title: '客户类型',
          align: 'center',
          dataIndex: 'custType',
          customRender: function (text) {
            if (text == 1) {
              return '个人';
            } else if (text == 0) {
              return '机构';
            } else if (text == 2) {
              return '产品';
            } else {
              return;
            }
          },
        },
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'mobile',
        },
        {
          title: 'email',
          align: 'center',
          dataIndex: 'email',
        },
        {
          title: '操作人',
          align: 'center',
          dataIndex: 'updateUser',
        },
        {
          title: '操作时间',
          align: 'center',
          dataIndex: 'updateTime',
        },
        {
          title: '原因',
          align: 'center',
          dataIndex: 'reason',
        },
        {
          title: '黑名单状态',
          align: 'center',
          dataIndex: 'isBlackList',
          scopedSlots: { customRender: 'isBlackList' },
        },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   fixed: 'right',
        //   width: 147,
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      url: {
        list: process.env.VUE_APP_CMS_CUSTOMER + '/customer/list',
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fundInfo/deleteBatch',
        importExcelUrl:
          process.env.VUE_APP_CMS_CUSTOMER + '/customer/blacklist/importExcel',
        exportXlsUrl:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/customer/blacklist/downExcelTemplate',
      },
      id: '',
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 删除文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    importFile() {
      this.exportVisible = true;
    },
    handleImportOk() {
      this.exportVisible = false;
    },
    handleCancel() {
      this.exportVisible = false;
    },
    handleImport(info) {
      console.warn(info.file.status);
      if (info.file.status == 'done') {
        if (this.fileList.length == 0) {
          return;
        }
        let formData = new FormData();
        formData.set('file', this.fileList[0]);
        postTag(this.url.importExcelUrl, formData)
          .then((res) => {
            if (res.success) {
              this.failData =
                res.result && res.result.invalidList
                  ? res.result.invalidList
                  : [];
              if (this.failData.length == 0) {
                this.exportVisible = false;
              }
              this.$message.success(res.message);
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            this.$message.error(err.message);
            this.fileList = [];
            this.showDialog = false;
          });
      }
    },
    //用户选择
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      console.log(this.selectedRowKeys);
    },

    channel() {
      this.showDialog = true;
    },
    //excel转换
    productToLead() {
      this.showLead = true;
    },
    // 文件上传
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      // return false;
    },

    // 导出excel
    handleExportExcel(fileName) {
      if (!fileName || typeof fileName != 'string') {
        fileName = '黑名单模版';
      }

      downFile(this.url.exportXlsUrl).then((data) => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xls'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
          this.searchQuery();
        }
      });
    },
    //批量删除
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        let ids = '';
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        let that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            getAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    searchQuery() {
      this.getList(1);
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      Blacklist(params).then((res) => {
        that.loading = true;
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          that.loading = false;
          that.ipagination.total = res.result.total;
        }
      });
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      var str = 'id';
      this.columns.forEach(function (value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },

    //启用、停用
    handleChange(record) {
      console.log(1);
      this.id = record.id;
      let strOpen = '确定要把客户加入黑名单?';
      let strClose = '确定要把客户拉出黑名单?';
      let that = this;
      let type = record.isBlackList == 1 ? 0 : 1;
      this.$confirm({
        title: record.isBlackList == 1 ? '禁用' : '未禁用',
        content: record.isBlackList == 1 ? strClose : strOpen,
        onOk() {
          addBlackListMessage({
            isBlackList: type,
            id: record.id,
            reason: '',
          }).then((res) => {
            if (res.success) {
              //刷新页面
              that.getList();
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        },
      });
      // if (record.isBlackList == 0) {
      //   this.reason = '';
      //   this.visible = true;
      // } else {
      // }
    },
    handleOk() {
      if (this.reason == '') {
        return '请输入拉入黑名单原因';
      }
      addBlacklist({ id: this.id, reason: this.reason, isBlackList: 1 }).then(
        (res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.visible = false;
            this.getList();
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    isChecked(statusTemp) {
      if (statusTemp == 1) {
        return true;
      } else return false;
    },
    //重置
    searchReset() {
      this.queryParam = {};
      this.getList(1);
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
